import React from 'react';

import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { pageInstance } from '@utils/page';
import { appMethod as app } from '@utils/app';

import './UserCenterContentCustomComponent.less';

export default class UserCenterContentCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let data = {};
    let content = pageInstance.state.eles[compindex].content;
    // 获取系统通知未读条数
    app.sendRequest({
      url: '/index.php?r=AppNotify/GetNotifyMsgUnreadCount',
      data: {
        'types': '3,5,6,16'
      },
      success: function (res) {
        let userData = {};
        let msgUnreadCount = {
          totalCount: 0,
          msgCount: res.data,
        };
        Object.keys(res.data).forEach(function (key) {
          if (key == 3) {
            msgUnreadCount.totalCount += 0;
          } else {
            msgUnreadCount.totalCount += +res.data[key].unread_count;
          }
        });
        if (msgUnreadCount.totalCount > 99) {
          msgUnreadCount.totalCount = '99+';
        }
        userData['eles[' + compindex + '].userData.msgUnreadCount'] = msgUnreadCount;
        pageInstance.setData(userData);
      }
    });
    let goodsTypeList = []
    for (let i = 0; i < 24; i++) {
      let sub = {
        requested: false,
        index: []
      }
      goodsTypeList.push(sub)
    };
    for (let i in content) {
      for (let j in content[i].blockArr) {
        let item = content[i].blockArr[j];
        if (item.actionType === 'custom') {
          let action = item.action;
          action.action = item.action.actionType;
          item.bindtap = "tapEventCommonHandler";
          item.param = action;
        } else {
          let goodsTypeReg = new RegExp('(^|&)goodsType=([^&]*)(&|$)');
          let orderIndex = new RegExp('(^|&)currentIndex=([^&]*)(&|$)');
          let goodsType = item.param && item.param.match(goodsTypeReg) ? +item.param.match(goodsTypeReg)[2] : -1;
          let k = item.param && item.param.match(orderIndex) ? +item.param.match(orderIndex)[2] : -1
          if (goodsType >= 0 && goodsType < 4) {
            goodsTypeList[goodsType].index.push([i, j, k])
          }

          if (item.router === 'myOrder' && goodsType != -1 && goodsTypeList[goodsType] && !goodsTypeList[goodsType].requested) {
            goodsTypeList[goodsType].requested = true;
            setTimeout(() => {
              this.userCenterOrderCount({
                goodsType: goodsType,
              }, (data) => {
                let newdata = {}
                data = [0, ...data]
                for (let i in goodsTypeList[goodsType].index) {
                  let index = goodsTypeList[goodsType].index[i]
                  newdata['eles[' + compindex + '].content[' + index[0] + ']blockArr[' + index[1] + ']count'] = +data[index[2]] || ''
                }
                pageInstance.setData(newdata)
              })
            }, 0);
          }
        }
      }
    }
    data['eles[' + compindex + '].content'] = content;
    pageInstance.setData(data)
  }

  userCenterOrderCount = (options, callback) => {
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/countStatusOrder',
      data: {
        parent_shop_app_id: app.getAppId(),
        goods_type: options.goodsType
      },
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          callback(res.data);
        }
      }
    });
  }

  userCenterTurnToPage = (e) => {
    app.userCenterTurnToPage(e)
  }

  tapEventCommonHandler = (e) => {
    app.tapEventCommonHandler(e)
  }

  render() {
    /**
     * 传入数据
     */
    const data = this.props.data;                // 组件数据
    const userData = data.userData || {};              // 用户数据
    /**
     * 页面上的数据
     */
    const storeStyle = pageInstance.data.storeStyle || {};   // 电商店铺样式数据
    /**
     * 组件配置对象
     */
    const customFeature = data.customFeature;

    return (
      <div className="custom-component user-center-content">
        {
          data.content.map((item, i) => (
            <div className="usercenter-block"
              key={i}
              style={{
                color: item['color'],
                marginTop: item['margin-top'] || '.2rem',
                backgroundColor: item['background-color'] || '#fff',
                backgroundImage: item['background-image'],
                textDecoration: item['text-decoration'],
                fontWeight: item['font-weight'],
                opacity: customFeature.blockStyle['opacity'] || 1,
                borderRadius: item['mode'] == 3 ? '.2rem' : transformPx2Rem(item['border-radius'], 320),
                width: 'calc(100% - ' + (item['mode'] == 3 ? '.2rem' : transformPx2Rem(item['margin'] * 2)) + ')'
              }}>
              {
                item.showName &&
                <div className="block-name" style={{
                  fontSize: item['font-size']
                }}>
                  {
                    item.customTitleImg && item.showAreaIcon &&
                    <img className="block-name-image" src={item.customTitleImg} alt="" />
                  }
                  <span>{item.name}</span>
                </div>
              }
              <div className="block-detail" style={{
                color: item['color'] || 'rgb(89, 96, 123)',
                lineHeight: transformPx2Rem(item['line-height'], 320)
              }}>
                {
                  item.blockArr.map((blockItem, j) => (
                    <React.Fragment key={j}>
                      {
                        (item.mode == 1 || item.mode == 3 || !item.mode) &&
                        <div className="block-item mode-one"
                          onClick={this[blockItem.bindtap]}
                          data-need-collect-info={userData.need_collect_info}
                          data-router={blockItem.router}
                          data-open-verify-phone={blockItem.openVerifyPhone || false}
                          data-event-params={JSON.stringify(blockItem.param)}
                          style={{
                            textAlign: 'center',
                            display: 'inline-block',
                            width: `calc(100% / ${item.col})`
                          }}
                        >
                          <div style={{
                            lineHeight: 'normal'
                          }}>
                            <div style={{
                              position: 'relative',
                              width: transformPx2Rem(item.imgHeight, 320),
                              height: transformPx2Rem(item.imgHeight, 320),
                              margin: '0 auto'
                            }}>
                              {
                                !blockItem.custom &&
                                <div className={`ico-moon ${blockItem.icon} ${data.customFeature.iconType == '2' ? '' : (i + 1) % 5 == 1 || (i + 1) % 5 == 4 ? 'color-1-4' : (i + 1) % 5 == 2 || (i + 1) % 5 == 0 ? 'color-2-5' : (i + 1) % 5 == 3 ? 'color-3' : ''}`} style={{
                                  fontSize: transformPx2Rem(item.imgHeight, 320),
                                  fontStyle: 'normal'
                                }}></div>
                              }
                              {
                                blockItem.custom &&
                                <img src={blockItem.custom} style={{
                                  width: transformPx2Rem(item.imgHeight, 320),
                                  height: item.imgHeight
                                }} />
                              }
                              {
                                blockItem.count &&
                                <span className="orderCount" style={{
                                  left: `calc(${item.imgHeight} - .14rem)`,
                                  backgroundColor: storeStyle.theme,
                                }}>{
                                    blockItem.count
                                  }</span>
                              }
                              {
                                blockItem.router == 'myMessage' && userData.msgUnreadCount && userData.msgUnreadCount.totalCount != 0 &&
                                <span className="message-unread-count"
                                  style={{
                                    left: `calc(${item.imgHeight} - .14rem)`,
                                    backgroundColor: storeStyle.theme,
                                  }}>
                                  {userData.msgUnreadCount.totalCount}
                                </span>
                              }
                              {
                                blockItem.action && blockItem.action.inner_page_link === 'myFormMessage' && userData.msgUnreadCount && userData.msgUnreadCount.msgCount['3'].unread_count != 0 &&
                                <span className="message-unread-count"
                                  style={{
                                    left: `calc(${item.imgHeight} - .14rem)`,
                                    backgroundColor: storeStyle.theme,
                                  }}>
                                  {userData.msgUnreadCount.msgCount[3].unread_count}
                                </span>
                              }
                            </div>
                            <span style={{
                              fontSize: transformPx2Rem(item['font-size'], 320),
                              textDecoration: item['text-decoration'] || ''
                            }}>
                              {blockItem.name}
                            </span>
                          </div>
                        </div>
                      }
                      {
                        item.mode == 2 &&
                        <div className="mode-two"
                          onClick={this[blockItem.bindtap]}
                          data-router={blockItem.router}
                          data-open-verify-phone={blockItem.openVerifyPhone}
                          data-event-params={JSON.stringify(blockItem.param)}
                          style={{
                            height: item.height,
                            lineHeight: item.height
                          }}
                        >
                          <div style={{
                            position: 'relative',
                            width: transformPx2Rem(item.imgHeight, 320),
                            height: transformPx2Rem(item.imgHeight, 320),
                            margin: '0 auto',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginLeft: '.40rem',
                            marginRight: '.20rem',
                          }}>
                            {
                              !blockItem.custom &&
                              <div className={`ico-moon ${blockItem.icon} ${data.customFeature.iconType == '2' ? '' : (i + 1) % 5 == 1 || (i + 1) % 5 == 4 ? 'color-1-4' : (i + 1) % 5 == 2 || (i + 1) % 5 == 0 ? 'color-2-5' : (i + 1) % 5 == 3 ? 'color-3' : ''}`} style={{
                                fontStyle: 'normal',
                                lineHeight: transformPx2Rem(item.imgHeight, 320),
                                fontSize: transformPx2Rem(item.imgHeight, 320),
                                width: transformPx2Rem(item.imgHeight, 320),
                                height: transformPx2Rem(item.imgHeight, 320),
                                verticalSlign: 'top'
                              }}></div>
                            }
                            {
                              blockItem.custom &&
                              <img src={blockItem.custom} style={{
                                width: transformPx2Rem(item.imgHeight, 320),
                                height: transformPx2Rem(item.imgHeight, 320),
                                verticalAlign: 'top'
                              }} />
                            }
                            {
                              blockItem.count &&
                              <span className="orderCount" style={{
                                left: `calc(${item.imgHeight} - .14rem)`,
                                backgroundColor: storeStyle.theme,
                              }}>{
                                  blockItem.count
                                }</span>
                            }
                            {
                              blockItem.router == 'myMessage' && userData.msgUnreadCount && userData.msgUnreadCount.totalCount != 0 &&
                              <span className="message-unread-count"
                                style={{
                                  left: `calc(${item.imgHeight} - .14rem)`,
                                  backgroundColor: storeStyle.theme,
                                }}>
                                {userData.msgUnreadCount.totalCount}
                              </span>
                            }
                            {
                              blockItem.action && blockItem.action.inner_page_link === 'myFormMessage' && userData.msgUnreadCount && userData.msgUnreadCount.msgCount['3'].unread_count != 0 &&
                              <span className="message-unread-count"
                                style={{
                                  left: `calc(${item.imgHeight} - .14rem)`,
                                  backgroundColor: storeStyle.theme,
                                }}>
                                {userData.msgUnreadCount.msgCount[3].unread_count}
                              </span>
                            }
                          </div>
                          <span style={{
                            verticalAlign: 'middle',
                            fontSize: transformPx2Rem(item['font-size'], 320),
                          }}>{blockItem.name}</span>
                        </div>
                      }
                    </React.Fragment>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/user-center-content-custom-component/UserCenterContentCustomComponent.jsx